const playful = {
  // 专区二级分类 - 白金泽
  premiumZoneClassify: `/authApi/box/v2/premiumZoneClassify`,
  // 贪玩专区 - banner - 白金泽
  getBannerList: `/authApi/box/v2/getPremiumBannerList`,
  // 贪玩专区 - 精选游戏 - 白金泽
  getGameList: `/authApi/box/v2/premiumGamesPage`,
  // 贪玩专区(其他专区) - 精选游戏 - 白金泽
  getOtherGameList: `/authApi/box/v2//zoneGamesPage`
};

export default playful;
